<template>
  <div>
    <CampTab :index="index" @tap="tapFn"></CampTab>
    <SpbcnWinnerCamp v-if="index === 0"></SpbcnWinnerCamp>
    <National v-else></National>
  </div>
</template>

<script>
import { camPage } from '@/http/api'
import CampTab from '@/components/camp_tab_component.vue'
import National from './camp/national.vue'
import SpbcnWinnerCamp from './camp/spbcnWinnerCamp.vue'

export default {
  components: {
    CampTab, National, SpbcnWinnerCamp
  },
  data () {
    return {
      index: 0,
      winnerCampList: [],
      summerCampList: [],
      auditList: [
        { productName: '2026北京夏令营', price: '¥5800', creator: '张三', createTime: '2026-06-01', auditStatus: 0 },
        { productName: '2026上海冬令营', price: '¥6800', creator: '李四', createTime: '2026-06-05', auditStatus: 1 },
        { productName: '2026深圳夏令营', price: '¥6200', creator: '王五', createTime: '2026-06-10', auditStatus: 2 },
        { productName: '2026深圳夏令营', price: '¥6200', creator: '王五', createTime: '2026-06-10', auditStatus: 2 }
      ]
    }
  },
  created () {
    // this.getCampList()
  },
  methods: {
    tapFn (index) {
      this.index = index
    },
    getCampList () {
      const year = new Date().getFullYear()
      camPage({ pageNum: 1, pageSize: 100, period: year }).then((res) => {
        this.winnerCampList = res.data.list.filter(item => item.type === 0)
        this.summerCampList = res.data.list.filter(item => item.type !== 0)
      }).catch((err) => {
        console.log('err', err)
      })
    },
    goCampDetail (id) {
      this.$router.push(
        {
          path: '/raceManagement/camp/campDetailsData',
          query: {
            campId: id
          }
        }
      )
    },
    formatDate (date) {
      return date.slice(0, 10)
    },
    formatDate2 (date) {
      return date.slice(5, 10)
    }
  }
}
</script>

<style scoped lang="less">
  .camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.4);
    }
    .status{
      font-size: 12px;
      font-weight: bold;
      color: #fff;
      background-color: #f00;
      padding: 2px 10px;
      position: absolute;
      right: 0;
      top: 0;
      border-radius: 0 10px 0 0;
    }
    .bg{
      width: 100%;
      height: 120px;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 2px 12px 10px;
      .name{
        height: 30px;
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #f00;
        margin-top: 10px;
      }
      .date{
        color: #969696;
        font-size: 12px;
        margin-top: 8px;
        text-align: right;
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
</style>
